<div class="docs-content">
    <div *ngIf="node?.order" class="order-node" [ngClass]="{'expanded': node.isExpandedResult}">
        {{node.order}}
    </div>
    <div style="display: flex; align-items: center; overflow: hidden;" [style.paddingLeft.px]="node.childLevel * 10">
        <div *ngIf="node.displayType === 'email'" class="fa-duotone fa-envelope"
            [ngClass]="{'selected-node': isSelected, 'docs-node': !isSelected}">
        </div>
        <div *ngIf="node.displayType === 'attachment'" class="fa-duotone fa-paperclip"
            [ngClass]="{'selected-node': isSelected, 'docs-node': !isSelected}">
        </div>
        <div *ngIf="node.displayType === 'native'" class="fa-duotone fa-file"
            [ngClass]="{'selected-node': isSelected, 'docs-node': !isSelected}"></div>
        <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{node.docTitle}}</div>
    </div>
</div>